/* eslint-disable indent */

export const equipmentSchema = {
    '$schema': 'http://json-schema.org/draft-04/schema#',
    'type': 'object',
    'properties': {
      'accessories': {
        'type': 'array',
        'items': [
          {
            'type': 'object',
            'properties': {
              'name': {
                'type': 'string'
              },
              'node': {
                'type': 'string'
              },
              'previewImage': {
                'type': 'string'
              }
            },
            'required': [
              'name',
              'node',
              'previewImage'
            ]
          }
        ]
      },
      'animations': {
        'type': 'array',
        'items': [
          {
            'type': 'object',
            'properties': {
              'key': {
                'type': 'string'
              },
              'node': {
                'type': 'string'
              },
              'type': {
                'type': 'string'
              }
            },
            'required': [
              'node',
              'type'
            ]
          }
        ]
      },
      'defaultSkin': {
        'type': 'string'
      },
      'dimensions': {
        'type': 'object',
        'properties': {
          'depth': {
            'type': 'number'
          },
          'height': {
            'type': 'number'
          },
          'width': {
            'type': 'number'
          }
        },
        'required': [
          'depth',
          'height',
          'width'
        ]
      },
      'id': {
        'type': 'string'
      },
      'model': {
        'type': 'string'
      },
      'name': {
        'type': 'string'
      },
      'preview-image': {
        'type': 'string'
      },
      'segments': {
        'type': 'array',
        'items': [
          {
            'type': 'string'
          },
          {
            'type': 'string'
          }
        ]
      },
      'shelf-groups': {
        'type': 'array',
        'items': [
          {
            'type': 'object',
            'properties': {
              'dimensions': {
                'type': 'object',
                'properties': {
                  'depth': {
                    'type': 'number'
                  },
                  'height': {
                    'type': 'number'
                  },
                  'width': {
                    'type': 'number'
                  }
                },
                'required': [
                  'depth',
                  'height',
                  'width'
                ]
              },
              'position': {
                'type': 'object',
                'properties': {
                  'x': {
                    'type': 'number'
                  },
                  'y': {
                    'type': 'number'
                  },
                  'z': {
                    'type': 'number'
                  }
                },
                'required': [
                  'x',
                  'y',
                  'z'
                ]
              },
              'shelves': {
                'type': 'array',
                'items': [
                  {
                    'type': 'object',
                    'properties': {
                      'dimensions': {
                        'type': 'object',
                        'properties': {
                          'depth': {
                            'type': 'number'
                          },
                          'height': {
                            'type': 'number'
                          },
                          'width': {
                            'type': 'number'
                          }
                        },
                        'required': [
                          'depth',
                          'height',
                          'width'
                        ]
                      },
                      'isAdjustable': {
                        'type': 'boolean'
                      },
                      'node': {
                        'type': 'string'
                      },
                      'order': {
                        'type': 'number'
                      },
                      'position': {
                        'type': 'object',
                        'properties': {
                          'x': {
                            'type': 'number'
                          },
                          'y': {
                            'type': 'number'
                          },
                          'z': {
                            'type': 'number'
                          }
                        },
                        'required': [
                          'x',
                          'y',
                          'z'
                        ]
                      }
                    },
                    'required': [
                      'dimensions',
                      'isAdjustable',
                      'node',
                      'order',
                      'position'
                    ]
                  }
                ]
              }
            },
            'required': [
              'dimensions',
              'position',
              'shelves'
            ]
          }
        ]
      },
      'skins': {
        'type': 'array',
        'items': [
          {
            'type': 'object',
            'properties': {
              'name': {
                'type': 'string'
              },
              'nodes': {
                'type': 'array',
                'items': [
                  {
                    'type': 'object',
                    'properties': {
                      'materials': {
                        'type': 'array',
                        'items': [
                          {
                            'type': 'object',
                            'properties': {
                              'material': {
                                'type': 'string'
                              },
                              'properties': {
                                'type': 'array',
                                'items': [
                                  {
                                    'type': 'object',
                                    'properties': {
                                      'image': {
                                        'type': 'string'
                                      },
                                      'property': {
                                        'type': 'string'
                                      }
                                    },
                                    'required': [
                                      'property'
                                    ]
                                  }
                                ]
                              }
                            },
                            'required': [
                              'material',
                              'properties'
                            ]
                          }
                        ]
                      },
                      'node': {
                        'type': 'string'
                      }
                    },
                    'required': [
                      'materials',
                      'node'
                    ]
                  }
                ]
              },
              'previewImage': {
                'type': 'string'
              }
            },
            'required': [
              'name',
              'nodes',
              'previewImage'
            ]
          }
        ]
      },
      'volume': {
        'type': 'number'
      },
      'weight': {
        'type': 'number'
      }
    },
    'required': [
      'dimensions',
      'model',
      'name',
      'volume',
      'weight'
    ]
  };

  export const productSchema = {
    '$schema': 'http://json-schema.org/draft-04/schema#',
    'type': 'object',
    'properties': {
      'preview-image': {
        'type': 'string'
      },
      'dimensions': {
        'type': 'object',
        'properties': {
          'width': {
            'type': 'number'
          },
          'height': {
            'type': 'number'
          },
          'depth': {
            'type': 'number'
          }
        },
        'required': [
          'width',
          'height',
          'depth'
        ]
      },
      'name': {
        'type': 'string'
      },
      'model': {
        'type': 'string'
      },
      'unit': {
        'type': 'string'
      },
      'size': {
        'type': 'integer'
      },
      'textures': {
        'type': 'array',
        'items': [
          {
            'type': 'object',
            'properties': {
              'name': {
                'type': 'string'
              }
            },
            'required': [
              'name'
            ]
          }
        ]
      }
    },
    'required': [
      'preview-image',
      'dimensions',
      'name',
      'model',
      'unit',
      'size'
    ]
  };

  export const planogramStickerScheme = {
    '$schema': 'http://json-schema.org/draft-04/schema#',
    'type': 'object',
    'properties': {
      'name': {
        'type': 'string'
      },
      'preview-image': {
        'type': 'string'
      },
      'image': {
        'type': 'string'
      },
      'dimensions': {
        'type': 'object',
        'properties': {
          'width': {
            'type': 'number'
          },
          'height': {
            'type': 'number'
          },
          'depth': {
            'type': 'number'
          }
        },
        'required': [
          'width',
          'height',
          'depth'
        ]
      }
    },
    'required': [
      'name',
      'preview-image',
      'image',
      'dimensions'
    ]
  };


// WEBPACK FOOTER //
// ./src/validation/Schemas.js